export default __webpack_public_path__ + "static/media/testimony3.873a5858.jpg";